import { api } from "../../utils/api";

export async function getBlocks(id) {
  const orderBlocks = (data) => {
    const dataArray = Object.values(data);
    dataArray.sort((a, b) => {
      const areNumbers = !isNaN(a.name) && !isNaN(b.name);
      if (areNumbers) {
        return a.name - b.name;
      }
      if (isNaN(a.name) && isNaN(b.name)) {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }
      return isNaN(a.name) ? 1 : -1;
    });

    const dataOrdenado = {};
    dataArray.forEach((item, index) => {
      dataOrdenado[index] = item;
    });
    return dataOrdenado;
  };
  
  try {
    const response =  await api.get(`blocks/${id}`);
    const formattedResponse = orderBlocks(response.data)
    return formattedResponse;
  } catch (error) {
    throw error;
  }
}

